import {Component} from '@angular/core';
import {SupportDeskKanbanComponent} from './kanban-board/support-desk-kanban.component';

@Component({
  selector: 'app-game-admin-support-desk',
  standalone: true,
  imports: [SupportDeskKanbanComponent],
  template: '<app-support-desk-kanban [isCrossGameView]="false"></app-support-desk-kanban>'
})
export class GameAdminSupportDeskComponent {}
